
var paginationLess = {};
import genaration from '../../utils/classname';
export var paginationClass = genaration(paginationLess, 'pagination');